import { normalizedTranslate } from '@rbilabs/components-library';
import styled from 'styled-components';

export const HeroHeading = styled.h1`
  color: ${Styles.color.white};
  font-family: ${Styles.fontFamily.base};
  font-size: 3.75rem;
  letter-spacing: -2px;
  line-height: 90%;
  margin: 0;
  text-align: center;
  text-transform: ${Styles.textTransform.headlines};
  width: 100%;

  ${Styles.desktop} {
    font-size: 6.25rem;
    margin-block-end: 2.5rem;
    text-align: start;
  }

  & small {
    display: inline-block;
    font-size: 3.4375rem;
    inset-inline-start: -5px;
    letter-spacing: -1px;
    position: relative;
    text-decoration: none;
    text-transform: lowercase;
    inset-block-start: -0.7rem;
    transform: ${normalizedTranslate(0, '0.2em')};
    vertical-align: top;

    ${Styles.desktop} {
      font-size: 6rem;
      inset-inline-start: -9px;
      position: relative;
      inset-block-start: -1.2rem;
    }
  }
`;
